<template>
  <Modal title="新建组织节点" :value="visible" @on-visible-change="visibleChange">
    <Form ref="unitForm" label-position="top" :model="unitModel" :rules="unitRule">
      <FormItem prop="unitName" label="名称">
        <Input type="text" v-model="unitModel.unitName" placeholder="节点名称"></Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button @click="cancel">Cancel</Button>
      <Button @click="save" type="primary">OK</Button>
    </div>
  </Modal>
</template>

<script>
import ajax from '../../../lib/ajax';

export default {
  data() {
    return {
      unitRule: {
        unitName: [{ required: true, message: '请输入节点名称' }]
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    unitModel: {
      type: Object,
      default: function () {
        return {
          unitName: '',
          type: 'create'
        }
      }
    },
    // 提交的数据Id
    unitData: {
      type: Object,
      default: function () {
        return {
          parentId: null
        }
      }
    }
  },
  methods: {
    cancel() {
      this.$refs.unitForm.resetFields();
      this.$emit('input', false);
    },
    save() {
      this.$refs.unitForm.validate(async (valid) => {
        if (valid) {
          let data = {
            parentId: this.unitData.parentId,
            displayName: this.unitModel.unitName
          }
          let rep = ''
          if (this.unitModel.type === 'create') {
            rep = await ajax.post('/api/services/app/OrganizationUnit/CreateOrganizationUnit', data)
          }
          if (this.unitModel.type === 'edit') {
            data.id = this.unitData.parentId
            delete data.parentId
            rep = await ajax.put('/api/services/app/OrganizationUnit/UpdateOrganizationUnit', data)
          }
          this.$refs.unitForm.resetFields();
          this.$emit('operateSuccess');
          this.$emit('input', false);
        }
      })
    },
    visibleChange(value) {
      if (!value) {
        this.$emit('input', value);
      }
    }
  }
}
</script>

